import React, { useEffect, useState ,useRef} from "react";
import { add, arrowDown, arrowUp, sub } from "../../../../../images"; // Adjust path
import useThemeTextColor from "../../../../utils/useThemeTextColor";
import PermissionControlledCard from "../../../../common/PermissionControlledCard";
import { useLocation } from "react-router-dom";

const KpiCard = ({
  kpi,
  index,
  transformKey,
  loadingState,
  dashboardSummary,
  toggleTooltip,
  activeTooltipIndex,
  setActiveTooltipIndex,
}) => (
  <div
    className="flex-shrink-0 w-100 kpi-inner-card h-100"
    onMouseLeave={() => setActiveTooltipIndex(null)}
    style={{ minWidth: "200px",maxWidth:"max-content", scrollSnapAlign: "start" }}
  >
    <div className="icon-wrapper mb-0 d-flex justify-content-between">
      <div>
        <p className="kpi-name" title={transformKey(kpi.name)}>{transformKey(kpi.name)}</p>

        <div className="price-tooltip-wrapper position-relative d-inline-block">
          <div className="kpi-sub-value" style={{ cursor: "pointer" }}>
            {loadingState?.dashboardSummary ? (
              <div className="skeleton skeleton-text w-75" />
            ) : (
              kpi.value
            )}
          </div>
          {!loadingState?.dashboardSummary && kpi.tooltip && (
            <div className="price-tooltip-box">{kpi.tooltip}</div>
          )}
        </div>
        <div className="kpi-percentage-div">
          <span
            className={`text-${kpi?.color === "red" ? "danger" : "success"}`}
          >
            {loadingState?.dashboardSummary ? (
              <div className="skeleton skeleton-text w-50 kpi-percentage" />
            ) : (
              <>
                <img alt="Arrow Icon" src={kpi?.color === "red" ? arrowDown : arrowUp}></img>
                <span className="ms-1 kpi-percentage">
                  {kpi?.past_change ? `${kpi.past_change} ` : ""}
                </span>
              </>
            )}
          </span>
        </div>
      </div>
      {kpi?.info && (
        <div className="info-tooltip-wrapper position-relative">
          <i
            className="bi bi-info-circle ms-2 text-secondary info-icon"
            style={{ cursor: "pointer" }}
            onClick={() => toggleTooltip(kpi?.info)}
          ></i>
          {activeTooltipIndex === kpi?.info && (
            <div className="info-tooltip-box">
              <p>{kpi?.info}</p>
            </div>
          )}
        </div>
      )}
    </div>
  </div>
);


const ScrollableKpiRow = ({
  kpis,
  transformKey,
  loadingState,
  dashboardSummary,
  toggleTooltip,
  activeTooltipIndex,
  setActiveTooltipIndex,
}) => {
  
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 0);
    setShowRightArrow(el.scrollLeft + el.clientWidth < el.scrollWidth);
  };

  const scroll = (distance) => {
    scrollRef.current.scrollBy({ left: distance, behavior: "smooth" });
  };

  useEffect(() => {
    handleScroll();
  }, [kpis]);

  return (
    <div className="kpi-scroll-wrapper position-relative">
      <div
        className="d-flex overflow-auto gap-3 p-2 hide-scrollbar px-0"
        style={{ scrollSnapType: "x mandatory" }}
        ref={scrollRef}
        onScroll={handleScroll}
      >
        {kpis.map((kpi, idx) => (
          <KpiCard
            key={idx}
            kpi={kpi}
            index={idx}
            transformKey={transformKey}
            loadingState={loadingState}
            dashboardSummary={dashboardSummary}
            toggleTooltip={toggleTooltip}
            activeTooltipIndex={activeTooltipIndex}
            setActiveTooltipIndex={setActiveTooltipIndex}
          />
        ))}
      </div>

      {/* Left Arrow */}
      {showLeftArrow && (
        <button className="kpi-scroll-arrow left" onClick={() => scroll(-200)}>
          <i className="bi bi-chevron-left"></i>
        </button>
      )}

      {/* Right Arrow */}
      {showRightArrow && (
        <button className="kpi-scroll-arrow right" onClick={() => scroll(200)}>
          <i className="bi bi-chevron-right"></i>
        </button>
      )}

      {/* Blur overlay */}
      {showLeftArrow && <div className="kpi-scroll-blur left-blur" />}
      {showRightArrow && <div className="kpi-scroll-blur right-blur" />}
    </div>
  );
};


const AccordionSection = ({
  title,
  kpis,
  isOpen,
  toggle,
  borderColor,
  textColor,
  showTitle = true,
  transformKey,
  loadingState,
  dashboardSummary,
  toggleTooltip,
  activeTooltipIndex,
  setActiveTooltipIndex,
  permission,
  sectionPermissionMap,

}) => {
  
  const permKey = sectionPermissionMap[title];
  const perm = permission?.[permKey];
  return(
  <div className="mb-2 mt-2">
    {showTitle && (
      <button
        className={`btn w-100 d-flex justify-content-between align-items-center Kpi-button ${isOpen ? "d-none" : ""}`}
        onClick={toggle}
        style={{
          borderColor,
          color: textColor,
          borderRadius: "0.5rem", // text matches border
          background: "transparent", // keep outline style
          boxShadow: "0px 1px 10px 0px rgba(0, 0, 0, 0.1)",
        }}
      >
        <span className="kpi-name">{title}</span>
        <span className="kpi-collapse-btn" style={{ fontSize: "1.5rem" }}>
          <i className={`bi ${isOpen ? "bi-dash" : "bi-plus"}`}></i>
          {/* <img src={isOpen ? sub : add} alt="Toggle" style={{ width: "24px", height: "24px", marginLeft: "5px", filter: `invert(${textColor === '#ffffff' ? 1 : 0})` }} /> */}
        </span>
      </button>
     )} 

    {isOpen && (
      <PermissionControlledCard
        // key={`${key}-${idx}`}
        permission={permission}
        colClass=""
        style={{
          flex: "0 0 auto", // 👈 no shrinking
          width: "250px",
          height: "auto", // 👈 fixed width for all cards
          scrollSnapAlign: "start", // 👈 snap nicely
        }}
      >
      <div
        className="flex-shrink-0 ps-2 pe-2 w-100 pt-2 w-100 mt-2 pb-2"
        style={{
          border: "1px solid #eee",
          borderRadius: "10px",
          color: textColor,
        }}
      >
        <div className="w-100 d-flex justify-content-between align-items-center">
          <span className="kpi-name">{title}</span>
          <span className="kpi-collapse-btn" style={{ fontSize: "1.5rem" }} onClick={toggle}>
            <i className={`bi ${isOpen ? "bi-dash" : "bi-plus"}`}></i>
          </span>
        </div>
          <ScrollableKpiRow
           kpis={kpis.map((kpi) => ({ ...kpi }))}
          transformKey={transformKey}
          loadingState={loadingState}
          dashboardSummary={dashboardSummary}
          toggleTooltip={toggleTooltip}
          activeTooltipIndex={activeTooltipIndex}
          setActiveTooltipIndex={setActiveTooltipIndex}
        />
        {/* <div
          className="d-flex overflow-auto gap-3 hide-scrollbar p-1"
          style={{ scrollSnapType: "x mandatory" }}
        >
          {kpis.map((kpi, idx) => (
            <KpiCard
              key={idx}
              kpi={kpi}
              index={idx}
              transformKey={transformKey}
              loadingState={loadingState}
              dashboardSummary={dashboardSummary}
              toggleTooltip={toggleTooltip}
              activeTooltipIndex={activeTooltipIndex}
              setActiveTooltipIndex={setActiveTooltipIndex}
            />
          ))}
        </div> */}
      </div>
      </PermissionControlledCard>
    )}
  </div>
)};

const KpiAccordion = ({
  data,
  permission,
  sectionPermissionMap,
  transformKey,
  loadingState,
  dashboardSummary,
  toggleTooltip,
  activeTooltipIndex,
  setActiveTooltipIndex,
  type,
  showWithGroupParent
}) => {
  const [openSection, setOpenSection] = useState(null);
  const [openSections, setOpenSections] = useState([]);
  const borderColor = useThemeTextColor("--gray-color");
  const textColor = useThemeTextColor("--text-color-accordion");
  const [isOpen, setIsOpen] = useState(true);
  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };
  const iconColor = useThemeTextColor("--black-color");
  const location = useLocation();
  const url = location.pathname === "/dashboard" ? true : false;

  const groupedSections = Object.entries(data).reduce((acc, [kpiKey, kpi]) => {
    const groupName = kpi.group_name || "Other"; // fallback if no group
    if (!acc[groupName]) acc[groupName] = [];
    // acc[groupName].push(kpi);
    acc[groupName][kpiKey] = kpi;
    return acc;
  }, {});

  const toggleSections = (key) => {
    setOpenSections(
      (prev) =>
        prev.includes(key)
          ? prev.filter((k) => k !== key) // close it
          : [...prev, key] // open it
    );
  };
  const sections = Object.entries(groupedSections);
  const collapsedKeys = sections.filter(([key]) => !openSections.includes(key));
  const totalCollapsed = collapsedKeys.length;
  // before your return(...)
  const firstGroupParent =
    sections
      .map(([, kpis]) =>
        Object.values(kpis).find(
          (kpi) => kpi?.group_parent && kpi?.group_parent.trim() !== ""
        )
      )
      .find(Boolean)?.group_parent || null;

  const SecondGroupParent = sections
    .map(([, kpis]) =>
      Object.values(kpis).find(
        (kpi) =>
          (kpi?.group_parent && kpi?.group_parent.trim() !== "") ||
          (kpi?.group_name && kpi?.group_name.trim() !== "")
      )
    )
    .find(Boolean);

  const secondGroupTitle = SecondGroupParent
    ? SecondGroupParent?.group_parent &&
      SecondGroupParent?.group_parent.trim() !== ""
      ? SecondGroupParent?.group_parent
      : SecondGroupParent?.group_name
    : null;
    const Wrapper = type === "child" 
    ? ({ children }) => (
        <PermissionControlledCard permission={permission} colClass="col-12 col-md-12 col-lg-12">
          {children}
        </PermissionControlledCard>
      )
    : React.Fragment;

  useEffect(() => {
    if (sections.length > 0 && !openSection && showWithGroupParent) {
      setOpenSection(sections?.[1]?.[0]); // pehle group ka key
      setOpenSections([sections?.[1]?.[0]]);
    }
    if(sections.length > 0 && !openSection && !showWithGroupParent) {
      setOpenSection(sections?.[0]?.[0]); // pehle group ka key
      setOpenSections([sections?.[0]?.[0]]);
    }
  
  }, []);
  return (
    <div className="kpi-accordion">
      {type === "child" && (
        // <PermissionControlledCard
        // permission={permission}
        // colClass="col-12 col-md-12 col-lg-12"
        // >
        <div className={(permission?.display && permission?.allowed) ? "d-block" : "d-none"}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="mb-0 kpi-heading"> {!url ? secondGroupTitle : firstGroupParent}</div>
          <div
            className={`collapse-btn`}
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen}
            aria-controls="kpiCollapse"
          >
            {/* <i className={`bi ${isOpen ? "bi-dash" : "bi-plus"}`}></i> */}
            <img src={isOpen ? sub : add} alt="Toggle" style={{ width: "24px", height: "24px", marginLeft: "5px", filter: `invert(${textColor === '#ffffff' ? 1 : 0})` }} />
          </div>
        </div>
        </div>
      // {/* // </PermissionControlledCard> */}
      )}
      <div className={`collapse ${isOpen ? "show" : ""}`} id="kpiCollapse">
        {type === "child" ? (
        <PermissionControlledCard
        permission={permission}
        colClass="d-none d-md-block"
        >
          <div className="collapsed-sections mt-2 d-none d-md-flex flex-wrap row">
            {sections.map(([key, kpis]) => {
              const isOpen = openSections.includes(key);
              const title = key;

              // 🧠 Determine dynamic column class
              let colClass = "col-12";
              if (!isOpen && url) {
                if (totalCollapsed === 4) colClass = "col-4";
                else if (totalCollapsed === 3) colClass = "col-6";
                else if (totalCollapsed === 2) colClass = "col-12";
                else colClass = "col-3";
              }
              else if (!isOpen && !url) {
                if (totalCollapsed >= 4) colClass = "col-6 col-lg-3";
                else if (totalCollapsed === 3) colClass = "col-6 col-lg-4";
                else if (totalCollapsed === 2) colClass = "col-6 col-lg-6";
                else colClass = "col-6 col-lg-12";
              }
              else colClass = "col-12";
              // map permissions from backend
              const permKey = sectionPermissionMap[key];
              const perm = permission?.[permKey];
              const filteredKpis = Object.entries(kpis).filter(([kpiKey, kpi]) =>
                showWithGroupParent
                  ? kpi?.group_parent && kpi?.group_parent.trim() !== ""
                  : !kpi?.group_parent || kpi?.group_parent.trim() === ""
              );

              if (filteredKpis?.length === 0) return null;
              // hide if both false
              if (!permission?.display && !permission?.allowed) return null;

              return (
                <div key={key} className={`mt-2 ${!isOpen ? colClass : "col-12"}`}>
                {/* // <PermissionControlledCard
                //   key={key}
                //   permission={permission}
                //   colClass={`mt-2 ${!isOpen ? colClass : "col-12"}`}
                // > */}
                  {/* Collapsed Button */}
                  {!isOpen && (
                    <button
                      className="btn d-flex justify-content-between align-items-center Kpi-button w-100 mt-1"
                      style={{
                        borderColor,
                        color: textColor,
                        borderRadius: "0.5rem",
                        background: "transparent",
                        boxShadow: "0px 1px 10px rgba(0, 0, 0, 0.1)",
                      }}
                      onClick={() => toggleSections(key)}
                    >
                      <span className="kpi-name">{title}</span>
                      <span className="kpi-collapse-btn" style={{ fontSize: "1.5rem" }}>
                        <i className="bi bi-plus"></i>
                      </span>
                    </button>
                  )}

                  {/* Open Section */}
                  {isOpen && (
                    <div className="kpi-inner-card">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="kpi-name">{title}</span>
                        {/* <span>{Object.entries(kpis)[0][1].group_parent || Object.entries(kpis)[0][1].group_name || title}</span> */}
                        <span
                          className="kpi-collapse-btn"
                          style={{ fontSize: "1.5rem", cursor: "pointer" }}
                          onClick={() => toggleSections(key)}
                        >
                          <i className="bi bi-dash"></i>
                        </span>
                      </div>
                          <ScrollableKpiRow
                            kpis={filteredKpis.map(([kpiKey, kpi]) => ({ ...kpi, name: kpiKey }))}
                            transformKey={transformKey}
                            loadingState={loadingState}
                            dashboardSummary={dashboardSummary}
                            toggleTooltip={toggleTooltip}
                            activeTooltipIndex={activeTooltipIndex}
                            setActiveTooltipIndex={setActiveTooltipIndex}
                          />

                      {/* <div
                        className="d-flex overflow-auto gap-3 hide-scrollbar"
                        style={{ scrollSnapType: "x mandatory" }}
                      >
                        {filteredKpis.map(([kpiKey, kpi], idx) => (
                          <KpiCard
                            key={idx}
                            kpi={{ ...kpi, name: kpiKey }} // pass key as name
                            index={idx}
                            transformKey={transformKey}
                            loadingState={loadingState}
                            dashboardSummary={dashboardSummary}
                            toggleTooltip={toggleTooltip}
                            activeTooltipIndex={activeTooltipIndex}
                            setActiveTooltipIndex={setActiveTooltipIndex}
                          />
                        ))}
                      </div> */}
                    </div>
                  )}
                {/* // </PermissionControlledCard> */}
                </div>
              );
            })}
          </div>
          </PermissionControlledCard>
        ) : (
           <PermissionControlledCard
                    // key={`${key}-${idx}`}
            permission={permission}
            colClass=""
          >
          <div className="collapsed-sections d-md-flex flex-wrap row mb-2 kpi-section pb-2">
            <div className="d-flex justify-content-between align-items-center p-0">
              <div className="kpi-heading"> {secondGroupTitle} </div>
            </div>

            {/* Single scrollable row for ALL cards */}
            <div
              className="gap-3 p-2 hide-scrollbar px-0"
            >
              {sections.map(([key, kpis]) => {
                const isOpen = openSections.includes(key);

                if (!permission?.display && !permission?.allowed) return null;

                const parentKpis = Object.entries(kpis).filter(
                  ([, kpi]) => kpi?.group_parent.trim() === ""
                );

                if (parentKpis.length === 0) return null;
                // 🧹 Clean KPI names — remove _times + any number suffix
                const cleanedParentKpis = parentKpis.map(([kpiKey, kpi]) => {
                  const cleanKey = kpiKey.replace(/_times\d+$/, ""); // removes _times2, _times10, etc.
                  return [cleanKey, kpi];
                });

                // parentKpis.map(([kpiKey, kpi], idx) => (
                return <div key={key}>
                {/* // <PermissionControlledCard
                //     // key={`${key}-${idx}`}
                //     permission={permission}
                //     colClass=""
                //     style={{
                //       flex: "0 0 auto", // 👈 no shrinking
                //       width: "250px",
                //       height: "auto", // 👈 fixed width for all cards
                //       scrollSnapAlign: "start", // 👈 snap nicely
                //     }}
                //   > */}
                    <ScrollableKpiRow
                      kpis={cleanedParentKpis.map(([kpiKey, kpi]) => ({ ...kpi, name: kpiKey }))}
                      transformKey={transformKey}
                      loadingState={loadingState}
                      dashboardSummary={dashboardSummary}
                      toggleTooltip={toggleTooltip}
                      activeTooltipIndex={activeTooltipIndex}
                      setActiveTooltipIndex={setActiveTooltipIndex}
                    />
                    </div> 
                  // </PermissionControlledCard>
                // ));
              })}
            </div>
          </div>
          </PermissionControlledCard>
        )}
      </div>

      {/* For mobile: show full accordion (like before) */}
      {type === "child" && (
        <div
          className={`d-md-none collapse ${isOpen ? "show" : ""}`}
          id="kpiCollapse"
        >
          {sections.map(([groupName, kpis]) => {

            const filteredKpis = Object.entries(kpis).filter(([kpiKey, kpi]) =>
                showWithGroupParent
                  ? kpi?.group_parent && kpi?.group_parent.trim() !== ""
                  : !kpi?.group_parent || kpi?.group_parent.trim() === ""
              );

            if (filteredKpis.length === 0) return null;

            return (
              <div key={groupName} className="mb-2">
                <AccordionSection
                  key={groupName}
                  title={groupName} // ✅ direct group name
                  kpis={filteredKpis.map(([kpiKey, kpi]) => ({
                    ...kpi,
                    name: kpiKey,
                  }))}
                  isOpen={openSection === groupName}
                  toggle={() => toggleSection(groupName)}
                  borderColor={borderColor}
                  textColor={textColor}
                  transformKey={transformKey}
                  loadingState={loadingState}
                  dashboardSummary={dashboardSummary}
                  permission={permission}
                  sectionPermissionMap={sectionPermissionMap}
                // showTitle={false}
                />
              </div>
            );
          })}
        </div>
        // </PermissionControlledCard>
      )}
    </div>
  );
};

export default KpiAccordion;
